import { backgroundFiles } from "@/mocks/home";

const typeIcon: Record<string, string> = {
  PDF: "ri-file-pdf-2-line",
  DOCX: "ri-file-word-2-line",
  XLSX: "ri-file-excel-2-line",
  ZIP: "ri-file-zip-line",
};

export default function BackgroundSection() {
  return (
    <section id="background" className="w-full bg-background-100 border-y border-background-200 px-4 md:px-8 py-14 md:py-20">
      <div className="max-w-[1360px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-9">
          <div>
            <span className="text-[11px] font-label tracking-[0.24em] text-secondary-600">BACKGROUND FILES</span>
            <h2 className="mt-2 font-heading text-3xl md:text-[2.4rem] font-black text-foreground-950">
              背景资料，一次打包带走
            </h2>
          </div>
          <p className="md:max-w-md text-sm leading-relaxed text-foreground-500">
            时间线对照表、文本比对稿与热度数据都已整理成文件，直接下载即可离线阅读。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-5 rounded-lg bg-primary-950 p-6 md:p-7 flex flex-col">
            <span className="inline-flex items-center gap-2 w-fit rounded-full bg-accent-500 text-accent-950 px-3 py-1 text-[11px] font-label">
              <i className="ri-download-cloud-2-line" />
              推荐下载
            </span>
            <h3 className="mt-4 font-heading text-2xl md:text-3xl font-black leading-snug text-background-50">
              事件完整资料包
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-primary-100">
              包含 4 份文件、9 个时间线节点截图与 48 小时的热度变化数据，适合需要完整还原事件过程的读者。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 text-[11px] font-label text-primary-200">
              <span className="flex items-center gap-1.5">
                <i className="ri-folder-3-line" />
                共 4 个文件
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-hard-drive-2-line" />
                合计 22.9 MB
              </span>
            </div>
            <button
              type="button"
              className="mt-7 inline-flex w-fit items-center gap-2 rounded-md bg-background-50 px-6 h-11 text-sm font-label text-primary-950 hover:bg-accent-300 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-download-2-line text-base" />
              立即下载资料包
            </button>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {backgroundFiles.map((file) => (
              <div
                key={file.title}
                className="group flex flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-5 hover:border-primary-300 transition-colors"
              >
                <div>
                  <div className="flex items-center justify-between">
                    <span className="flex items-center justify-center w-10 h-10 rounded-md bg-secondary-100 text-secondary-700">
                      <i className={`${typeIcon[file.type] ?? "ri-file-line"} text-xl`} />
                    </span>
                    <span className="text-[11px] font-label tracking-[0.14em] text-foreground-400">{file.type}</span>
                  </div>
                  <h3 className="mt-3.5 font-heading text-base font-bold text-foreground-950">{file.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-500">{file.desc}</p>
                </div>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="text-[11px] font-label text-foreground-400">{file.size}</span>
                  <button
                    type="button"
                    className="inline-flex items-center gap-1 text-[11px] font-label text-primary-600 cursor-pointer"
                  >
                    <i className="ri-download-line" />
                    下载
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}